import apiService from './apiService';

const authService = {
  login: async (email, password) => {
    try {
      const response = await apiService.post('/api/auth/login', {
        email,
        password
      });
      return response;
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          throw new Error('Credenciales inválidas');
        } else if (error.response.status === 400) {
          throw new Error(error.response.data.message || 'Error en la solicitud');
        } else if (error.response.status === 500) {
          throw new Error('Error del servidor');
        }
      }
      throw error;
    }
  }
};

export default authService;